import React from "react";

function Projects() {
  return (
    <div id="project-container">
      <h2 id="projects-h1">Projects</h2>
      <div className="project">
        <section className="name-icon-container">
          <h3 className="project-name">CSS Avatars</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="35"
            height="35"
            viewBox="0 0 172 172"
            style={{ fill: "#000000" }}
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style={{ mixBlendMode: "normal" }}
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g>
                <path
                  d="M35.11667,17.54042v0c0.00593,14.68781 11.91127,26.59315 26.59908,26.59908v0c-14.68781,0.00593 -26.59315,11.91127 -26.59908,26.59908v0c-0.00593,-14.68781 -11.91127,-26.59315 -26.59908,-26.59908v0c14.68781,-0.00593 26.59315,-11.91127 26.59908,-26.59908z"
                  fill="#ff80d8"
                ></path>
                <path
                  d="M35.11667,19.11708v0c0.00593,13.81564 11.20319,25.01451 25.01883,25.02242v0c-13.81506,0.00593 -25.0129,11.20377 -25.01883,25.01883v0c-0.00593,-13.81506 -11.20377,-25.0129 -25.01883,-25.01883v0c13.81564,-0.00791 25.0129,-11.20677 25.01883,-25.02242z"
                  fill="#ff80d8"
                ></path>
                <path
                  d="M35.11667,20.69733v0c0.00791,12.94347 10.49869,23.43426 23.44217,23.44217v0c-12.94429,0.00593 -23.43623,10.49787 -23.44217,23.44217v0c-0.00593,-12.94429 -10.49787,-23.43623 -23.44217,-23.44217v0c12.94347,-0.00791 23.43426,-10.49869 23.44217,-23.44217z"
                  fill="#ff80d8"
                ></path>
                <path
                  d="M35.11667,22.274v0c0.00988,12.06793 9.7904,21.84845 21.85833,21.85833v0c-12.07202,0 -21.85833,9.78631 -21.85833,21.85833v0c0,-12.07202 -9.78631,-21.85833 -21.85833,-21.85833v0c12.06793,-0.00988 21.84845,-9.7904 21.85833,-21.85833z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,23.85425v0c0.00791,11.19996 9.08529,20.27734 20.28525,20.28525v0c-11.20078,0.00593 -20.27932,9.08447 -20.28525,20.28525v0c-0.00396,-11.2016 -9.08365,-20.28129 -20.28525,-20.28525v0c11.20078,-0.00593 20.27932,-9.08447 20.28525,-20.28525z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,25.44167v0c0.00593,10.33001 8.37858,18.70265 18.70858,18.70858v0c-10.32523,0.00395 -18.69672,8.36902 -18.70858,18.69425v0c-0.00593,-10.32943 -8.37916,-18.70105 -18.70858,-18.705v0c10.32581,-0.00592 18.69673,-8.37202 18.70858,-18.69783z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,27.00758v0c0.00395,9.45866 7.66968,17.12598 17.12833,17.13192v0c-9.46088,0.00396 -17.12833,7.67462 -17.12833,17.1355v0c-0.00395,-9.45808 -7.67025,-17.12438 -17.12833,-17.12833v0c9.46146,-0.00593 17.12834,-7.67763 17.12833,-17.13908z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,28.58783v0c0.00395,8.58731 6.96436,15.54771 15.55167,15.55167v0c-8.58591,0.00395 -15.54574,6.96217 -15.55167,15.54808v0c-0.00396,-8.58673 -6.96494,-15.54611 -15.55167,-15.54808v0c8.58731,-0.00395 15.54771,-6.96436 15.55167,-15.55167z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,30.1645v0c0,7.71818 6.25682,13.975 13.975,13.975v0c-7.71818,0 -13.975,6.25682 -13.975,13.975v0c0,-7.71818 -6.25682,-13.975 -13.975,-13.975v0c7.71818,0 13.975,-6.25682 13.975,-13.975z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,31.74475v0c0.00395,6.84379 5.55096,12.3908 12.39475,12.39475v0c-6.84379,0.00395 -12.3908,5.55096 -12.39475,12.39475v0c-0.00395,-6.84379 -5.55096,-12.3908 -12.39475,-12.39475v0c6.84379,-0.00395 12.3908,-5.55096 12.39475,-12.39475z"
                  fill="#ffbddf"
                ></path>
                <path
                  d="M35.11667,33.325v0c0.00395,5.97302 4.84506,10.81413 10.81808,10.81808v0c-5.97186,0 -10.81413,4.83905 -10.81808,10.81092v0c-0.00198,-5.97186 -4.84264,-10.81252 -10.8145,-10.8145v0c5.97023,-0.00593 10.80857,-4.84427 10.8145,-10.8145z"
                  fill="#ffe8f1"
                ></path>
                <path
                  d="M35.11667,34.90167v0c0.00395,5.10028 4.13756,9.23388 9.23783,9.23783v0c-2.45222,0.00095 -4.80352,0.97649 -6.53615,2.71182c-1.73264,1.73532 -2.70453,4.08813 -2.70168,6.54035v0c0,-5.10191 -4.13592,-9.23783 -9.23783,-9.23783v0c2.45193,-0.0019 4.80267,-0.97775 6.5351,-2.71286c1.73243,-1.73512 2.70463,-4.08738 2.70273,-6.5393z"
                  fill="#ffe8f1"
                ></path>
                <g>
                  <path
                    d="M46.0745,106.74392v0c0,12.07202 9.78631,21.85833 21.85833,21.85833v0c-12.07202,0 -21.85833,9.78631 -21.85833,21.85833v0c0,-12.07202 -9.78631,-21.85833 -21.85833,-21.85833v0c12.07202,0 21.85833,-9.78631 21.85833,-21.85833z"
                    fill="#ff80d8"
                  ></path>
                  <path
                    d="M46.0745,108.04108v0c0.00396,11.34804 9.20237,20.54646 20.55042,20.55042v0c-11.34804,0.00396 -20.54646,9.20237 -20.55042,20.55042v0c-0.00396,-11.34804 -9.20237,-20.54646 -20.55042,-20.55042v0c11.34722,-0.00593 20.54449,-9.20319 20.55042,-20.55042z"
                    fill="#ff80d8"
                  ></path>
                  <path
                    d="M46.0745,109.33825v0c0.00396,10.63164 8.62161,19.24929 19.25325,19.25325v0c-10.63164,0.00396 -19.24929,8.62161 -19.25325,19.25325v0c-0.00396,-10.63164 -8.62161,-19.24929 -19.25325,-19.25325v0c10.63164,-0.00396 19.24929,-8.62161 19.25325,-19.25325z"
                    fill="#ff80d8"
                  ></path>
                  <path
                    d="M46.0745,110.63542v0c0.00396,9.91523 8.04085,17.95213 17.95608,17.95608v0c-9.91943,0.00396 -17.95806,8.0474 -17.95608,17.96683v0c-0.00396,-9.91523 -8.04085,-17.95213 -17.95608,-17.95608v0c9.91523,-0.00396 17.95213,-8.04085 17.95608,-17.95608z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,111.929v0c0.00198,9.20023 7.45869,16.65854 16.65892,16.6625v0c-9.20023,0.00396 -16.65694,7.46227 -16.65892,16.6625v0c-0.00198,-9.20163 -7.46087,-16.66052 -16.6625,-16.6625v0c9.20163,-0.00198 16.66052,-7.46087 16.6625,-16.6625z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,113.23333v0c0.00395,8.4844 6.88093,15.36138 15.36533,15.36533v0c-8.4844,0.00395 -15.36138,6.88093 -15.36533,15.36533v0c0,-8.4872 -6.87813,-15.36854 -15.36533,-15.3725v0c8.4816,-0.00395 15.35743,-6.87656 15.36533,-15.35817z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,114.52333v0c0.00395,7.768 6.30017,14.06421 14.06817,14.06817v0c-7.768,0.00395 -14.06421,6.30017 -14.06817,14.06817v0c-0.00395,-7.768 -6.30017,-14.06421 -14.06817,-14.06817v0c7.768,-0.00395 14.06421,-6.30017 14.06817,-14.06817z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,115.8205v0c0.00395,7.05159 5.71941,12.76705 12.771,12.771v0c-7.05159,0.00395 -12.76705,5.71941 -12.771,12.771v0c-0.00396,-7.05299 -5.72159,-12.76902 -12.77458,-12.771v0c7.05299,-0.00198 12.77063,-5.71801 12.77458,-12.771z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,117.11408v0c0,6.33287 5.1338,11.46667 11.46667,11.46667v0c-6.33287,0 -11.46667,5.1338 -11.46667,11.46667v0c0,-6.33287 -5.1338,-11.46667 -11.46667,-11.46667v0c6.33287,0 11.46667,-5.1338 11.46667,-11.46667z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,118.41125v0c0.00198,5.62298 4.56086,10.18025 10.18383,10.18025v0c-5.62158,0.00198 -10.17827,4.55867 -10.18025,10.18025v0c-0.00198,-5.62158 -4.55867,-10.17827 -10.18025,-10.18025v0c5.62158,-0.00198 10.17827,-4.55867 10.18025,-10.18025z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M46.0745,119.70842v0c0.00198,4.90517 3.97791,8.88111 8.88308,8.88308v0c-4.90517,0.00198 -8.88111,3.97791 -8.88308,8.88308v0c-0.00198,-4.90517 -3.97791,-8.88111 -8.88308,-8.88308v0c4.90517,-0.00198 8.88111,-3.97791 8.88308,-8.88308z"
                    fill="#ffe8f1"
                  ></path>
                  <path
                    d="M46.0745,121.00558v0c0.00198,4.18877 3.39715,7.58394 7.58592,7.58592v0c-4.18539,0 -7.57999,3.38978 -7.58592,7.57517v0c-0.00198,-4.19017 -3.39933,-7.58592 -7.5895,-7.58592v0c4.18935,-0.00198 7.58555,-3.39657 7.5895,-7.58592z"
                    fill="#ffe8f1"
                  ></path>
                </g>
                <g>
                  <path
                    d="M98.857,21.55733v0c0.01384,37.00195 30.00639,66.99449 67.00833,67.00833v0c-37.00276,0.01187 -66.99647,30.00557 -67.00833,67.00833v0c0,-37.00768 -30.00065,-67.00833 -67.00833,-67.00833v0c37.00195,-0.01384 66.99449,-30.00639 67.00833,-67.00833z"
                    fill="#ff80d8"
                  ></path>
                  <path
                    d="M98.857,25.53483v0c0.02372,34.79718 28.22649,62.99995 63.02367,63.02367v0c-34.79439,0.02371 -62.996,28.22212 -63.02367,63.0165v0c-0.02767,-34.79438 -28.22928,-62.99279 -63.02367,-63.0165v0c34.79718,-0.02372 62.99995,-28.22649 63.02367,-63.02367z"
                    fill="#ff80d8"
                  ></path>
                  <path
                    d="M98.857,29.50875v0c0.01779,32.6049 26.44485,59.03196 59.04975,59.04975v0c-32.60432,0.01582 -59.03196,26.44184 -59.04975,59.04617v0c-0.01384,-32.60456 -26.4416,-59.03232 -59.04617,-59.04617v0c32.60432,-0.01779 59.03035,-26.44543 59.04617,-59.04975z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M98.857,33.48267v0c0.01581,30.40959 24.66266,55.05804 55.07225,55.07583v0c-30.40983,0.01384 -55.05841,24.66242 -55.07225,55.07225v0c-0.01187,-30.41065 -24.6616,-55.06038 -55.07225,-55.07225v0c30.41041,-0.01582 55.05841,-24.66542 55.07225,-55.07583z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M98.857,37.46017v0c0.01384,28.2151 22.88324,51.08449 51.09833,51.09833v0c-28.21452,0.01186 -51.08449,22.88024 -51.09833,51.09475v0c-0.00989,-28.21475 -22.88,-51.08486 -51.09475,-51.09475v0c28.21451,-0.01384 51.08289,-22.88382 51.09475,-51.09833z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M98.857,41.43408v0c0.01384,26.02036 21.10405,47.11058 47.12442,47.12442v0c-26.01978,0.01186 -47.11058,21.10105 -47.12442,47.12083v0c-0.01186,-26.0192 -21.10163,-47.10897 -47.12083,-47.12083v0c26.01978,-0.01384 47.10897,-21.10463 47.12083,-47.12442z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M98.857,45.41158v0c0.01581,23.82283 19.32409,43.1311 43.14692,43.14692v0c-23.82307,0.01186 -43.13308,19.32026 -43.14692,43.14333v0c-0.01186,-23.82389 -19.32303,-43.13345 -43.14692,-43.14333v0c23.82447,-0.01186 43.13505,-19.32245 43.14692,-43.14692z"
                    fill="#ffbddf"
                  ></path>
                  <path
                    d="M98.857,49.3855v0c0.01186,21.62974 17.54326,39.16114 39.173,39.173v0c-21.62997,0.00791 -39.16311,17.53944 -39.173,39.16942v0c-0.00791,-21.62939 -17.54002,-39.16151 -39.16942,-39.16942v0c21.62997,-0.00989 39.16151,-17.54303 39.16942,-39.173z"
                    fill="#ffe8f1"
                  ></path>
                  <path
                    d="M98.857,53.35942v0c0.00988,19.43442 15.76108,35.18722 35.1955,35.19908v0c-19.43384,0.00989 -35.18561,15.76166 -35.1955,35.1955v0c-0.00593,-19.43548 -15.76002,-35.18957 -35.1955,-35.1955v0c19.43524,-0.00989 35.18759,-15.76384 35.1955,-35.19908z"
                    fill="#ffe8f1"
                  ></path>
                  <path
                    d="M98.857,57.33333v0c0.00791,17.23911 13.97889,31.2133 31.218,31.22517v0c-17.23853,0.00791 -31.2117,13.97947 -31.22158,31.218v0c-0.00593,-17.23877 -13.97923,-31.21207 -31.218,-31.218v0c17.24133,-0.00791 31.21565,-13.98384 31.22158,-31.22517z"
                    fill="#ffe8f1"
                  ></path>
                  <path
                    d="M98.857,61.31083v0c0.01383,15.03482 12.19851,27.2195 27.23333,27.23333v0c-15.03564,0.01186 -27.22148,12.19769 -27.23333,27.23333v0c-0.01186,-15.03564 -12.19769,-27.22148 -27.23333,-27.23333v0c15.03482,-0.01383 27.2195,-12.19851 27.23333,-27.23333z"
                    fill="#ffe8f1"
                  ></path>
                  <path
                    d="M98.857,65.28833v0c0.01185,12.84685 10.42332,23.25831 23.27017,23.27017v0c-12.84545,0.01185 -23.25634,10.42114 -23.27017,23.26658v0c-0.0138,-12.83707 -10.41162,-23.24289 -23.24867,-23.26658v0c12.84545,-0.01383 23.25473,-10.42472 23.26658,-23.27017z"
                    fill="#ffe8f1"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </section>
        <p>
          A generator that outputs the code for custom CSS avatars based on user
          input. Built with: <span className="emphasis">JavaScript</span>,{" "}
          <span className="emphasis">CSS</span> and{" "}
          <span className="emphasis">HTML</span>.
        </p>
        <section className="repo-demo-container">
          <a
            href="https://github.com/aleksarad/css-avatars"
            rel="noopener noreferrer"
            target="_blank"
          >
            Repo
          </a>
          <a
            href="https://aleksarad.github.io/css-avatars/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Live
          </a>
        </section>
      </div>

      <div className="project">
        <section className="name-icon-container">
          <h3 className="project-name">Glowlist</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="40"
            height="40"
            viewBox="0 0 172 172"
            style={{ fill: "#000000" }}
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style={{ mixBlendMode: "normal" }}
            >
              <path d="M0,172v-172h172v172z" fill="none" stroke="none"></path>
              <g>
                <path
                  d="M48.3105,103.63l39.087,-33.5056l71.6079,-62.8789l5.7491,5.7491l-62.8617,71.5864l-33.5228,39.1085z"
                  fill="#ffa9cd"
                  stroke="none"
                ></path>
                <path
                  d="M158.9108,10.191l2.9025,2.9025l-61.5717,70.1072l-31.992,37.324l-16.7743,-16.7743l37.3627,-32.0264l70.0728,-61.533M159.1,4.3l-73.1,64.1947l-40.85,35.0149l23.3447,23.3447l35.0149,-40.85l64.1904,-73.1043l-8.6,-8.6z"
                  fill="#dd85a3"
                  stroke="none"
                ></path>
                <path
                  d="M48.0697,165.55c-22.9491,0 -41.6197,-18.6706 -41.6197,-41.6197c0,-6.5704 1.1997,-12.814 3.569,-18.5803h56.631v56.717c-4.8375,2.2532 -11.3735,3.483 -18.5803,3.483z"
                  fill="#ffa9cd"
                  stroke="none"
                ></path>
                <path
                  d="M64.5,107.5v53.1566c-4.4118,1.7802 -10.1351,2.7434 -16.4303,2.7434c-21.7666,0 -39.4697,-17.7031 -39.4697,-39.4697c0,-5.7835 0.9675,-11.3004 2.8853,-16.4303h53.0147M68.8,103.2h-60.2c-2.8595,6.407 -4.3,13.3515 -4.3,20.7303c0,24.1746 19.5951,43.7697 43.7697,43.7697c7.3831,0 14.9726,-1.247 20.7303,-4.3v-60.2z"
                  fill="#dd85a3"
                  stroke="none"
                ></path>
                <path
                  d="M48.3105,103.63l37.5777,-32.207l14.6888,14.6888l-32.207,37.5777z"
                  fill="#ffd4e7"
                  stroke="none"
                ></path>
                <path
                  d="M85.7764,74.347l11.8766,11.8766l-29.3991,34.3011l-16.7743,-16.7743l34.2968,-29.4034M86,68.4947l-40.85,35.0149l23.3447,23.3447l35.0149,-40.85l-17.5096,-17.5096z"
                  fill="#dd85a3"
                  stroke="none"
                ></path>
                <path
                  d="M92.2952,96.5952l-17.2,-17.2"
                  fill="none"
                  stroke="#dd85a3"
                ></path>
                <path
                  d="M8.6,120.4h25.8l-25.8,12.9z"
                  fill="#dd85a3"
                  stroke="none"
                ></path>
              </g>
            </g>
          </svg>
        </section>
        <p>
          A full-stack makeup planning app that allows users to sketch out and
          save their ideas for makeup looks. Built with:{" "}
          <span className="emphasis">Ruby on Rails</span>,{" "}
          <span className="emphasis">PostgreSQL</span> and{" "}
          <span className="emphasis">React</span>.
        </p>
        <section className="repo-demo-container">
          <a
            href="https://github.com/aleksarad/glowlist-frontend"
            rel="noopener noreferrer"
            target="_blank"
          >
            Repo
          </a>
          <a
            href="https://glowlist.netlify.app/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Live
          </a>
          <a
            href="https://www.loom.com/share/9427770cfbdc4d27989265917ab46aab/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Demo
          </a>
        </section>
      </div>
      <div className="project">
        <section className="name-icon-container">
          <h3 className="project-name">Doodl</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="40"
            height="40"
            viewBox="0 0 172 172"
            style={{ fill: "#000000" }}
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style={{ mixBlendMode: "normal" }}
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g>
                <path
                  d="M86.8901,165.55c-22.6266,0 -44.247,-9.6836 -59.3357,-26.5654c-15.2951,-17.1097 -22.2869,-39.216 -19.6897,-62.2468c4.0291,-35.7029 32.7789,-64.9773 68.3657,-69.5912c3.5475,-0.4601 7.1337,-0.6966 10.664,-0.6966c34.3097,0 64.6419,21.8526 75.4822,54.3778c1.4706,4.3946 4.3903,15.4327 -0.1333,22.8545c-2.3435,3.8442 -6.4973,6.2479 -12.3367,7.1552c-2.2102,0.3397 -6.2651,0.8557 -10.9822,1.419c-8.0281,0.9632 -15.351,5.2675 -20.0939,11.8121c-4.7386,6.536 -6.5403,14.8135 -4.9579,22.7212l0.9245,4.6311c1.6813,8.4022 -0.4644,17.0237 -5.8867,23.6543c-5.4309,6.6349 -13.4547,10.4533 -22.0203,10.4748zM81.7,118.25c-8.299,0 -15.05,6.751 -15.05,15.05c0,8.299 6.751,15.05 15.05,15.05c8.299,0 15.05,-6.751 15.05,-15.05c0,-8.299 -6.751,-15.05 -15.05,-15.05z"
                  fill="#ffe8f1"
                ></path>
                <path
                  d="M86.8944,8.6c33.3809,0 62.8961,21.2635 73.444,52.9072c1.0707,3.2121 4.2355,14.2158 0.0645,21.0614c-2.0253,3.3239 -5.5685,5.332 -10.8317,6.149c-1.9608,0.3053 -5.6287,0.7783 -10.9048,1.4104c-8.6215,1.032 -16.4862,5.6545 -21.5817,12.6807c-5.0869,7.0176 -7.0262,15.9143 -5.3277,24.4111l0.9245,4.6311c1.5523,7.7658 -0.43,15.738 -5.4481,21.8741c-5.0138,6.1318 -12.4356,9.6621 -20.3476,9.6793c-22.0117,0 -43.0559,-9.4213 -57.7361,-25.8473c-14.878,-16.6496 -21.6849,-38.1625 -19.1565,-60.5698c3.9259,-34.744 31.8931,-63.2186 66.5124,-67.7121c3.4529,-0.4472 6.9488,-0.6751 10.3888,-0.6751M81.7,150.5c9.4858,0 17.2,-7.7142 17.2,-17.2c0,-9.4858 -7.7142,-17.2 -17.2,-17.2c-9.4858,0 -17.2,7.7142 -17.2,17.2c0,9.4858 7.7142,17.2 17.2,17.2M86.8944,4.3c-3.5991,0 -7.2498,0.2322 -10.9435,0.7138c-36.6919,4.7601 -66.0738,34.7182 -70.2233,71.4875c-5.5642,49.3726 32.9165,91.1987 81.1668,91.1987c19.3285,-0.0473 33.8023,-17.7418 30.0097,-36.6962l-0.9245,-4.6311c-3.0788,-15.3854 7.6239,-30.1129 23.2028,-31.9791c4.7429,-0.5676 8.8322,-1.0836 11.051,-1.4276c21.5602,-3.3411 16.899,-24.6949 14.19,-32.8176c-10.8231,-32.4521 -41.4477,-55.8484 -77.529,-55.8484zM81.7,146.2c-7.1251,0 -12.9,-5.7749 -12.9,-12.9c0,-7.1251 5.7749,-12.9 12.9,-12.9c7.1251,0 12.9,5.7749 12.9,12.9c0,7.1251 -5.7749,12.9 -12.9,12.9z"
                  fill="#ff93c1"
                ></path>
                <path
                  d="M40.85,92.45c-7.12447,0 -12.9,5.77553 -12.9,12.9c0,7.12447 5.77553,12.9 12.9,12.9c7.12447,0 12.9,-5.77553 12.9,-12.9c0,-7.12447 -5.77553,-12.9 -12.9,-12.9z"
                  fill="#ffd1e6"
                ></path>
                <path
                  d="M40.85,94.6c5.9297,0 10.75,4.8203 10.75,10.75c0,5.9297 -4.8203,10.75 -10.75,10.75c-5.9297,0 -10.75,-4.8246 -10.75,-10.75c0,-5.9254 4.8203,-10.75 10.75,-10.75M40.85,90.3c-8.3119,0 -15.05,6.7381 -15.05,15.05c0,8.3119 6.7381,15.05 15.05,15.05c8.3119,0 15.05,-6.7381 15.05,-15.05c0,-8.3119 -6.7381,-15.05 -15.05,-15.05z"
                  fill="#ff93c1"
                ></path>
                <path
                  d="M40.85,49.45c-7.12447,0 -12.9,5.77553 -12.9,12.9c0,7.12447 5.77553,12.9 12.9,12.9c7.12447,0 12.9,-5.77553 12.9,-12.9c0,-7.12447 -5.77553,-12.9 -12.9,-12.9z"
                  fill="#ffa9cd"
                ></path>
                <path
                  d="M40.85,51.6c5.9297,0 10.75,4.8203 10.75,10.75c0,5.9297 -4.8203,10.75 -10.75,10.75c-5.9297,0 -10.75,-4.8203 -10.75,-10.75c0,-5.9297 4.8203,-10.75 10.75,-10.75M40.85,47.3c-8.3119,0 -15.05,6.7381 -15.05,15.05c0,8.3119 6.7381,15.05 15.05,15.05c8.3119,0 15.05,-6.7381 15.05,-15.05c0,-8.3119 -6.7381,-15.05 -15.05,-15.05z"
                  fill="#ff93c1"
                ></path>
                <g>
                  <path
                    d="M75.25,23.65c-7.12447,0 -12.9,5.77553 -12.9,12.9c0,7.12447 5.77553,12.9 12.9,12.9c7.12447,0 12.9,-5.77553 12.9,-12.9c0,-7.12447 -5.77553,-12.9 -12.9,-12.9z"
                    fill="#ffd1e6"
                  ></path>
                  <path
                    d="M75.25,25.8c5.9297,0 10.75,4.8203 10.75,10.75c0,5.9297 -4.8203,10.75 -10.75,10.75c-5.9297,0 -10.75,-4.8203 -10.75,-10.75c0,-5.9297 4.8203,-10.75 10.75,-10.75M75.25,21.5c-8.3119,0 -15.05,6.7381 -15.05,15.05c0,8.3119 6.7381,15.05 15.05,15.05c8.3119,0 15.05,-6.7381 15.05,-15.05c0,-8.3119 -6.7381,-15.05 -15.05,-15.05z"
                    fill="#ff93c1"
                  ></path>
                </g>
                <g>
                  <path
                    d="M118.25,32.25c-7.12447,0 -12.9,5.77553 -12.9,12.9c0,7.12447 5.77553,12.9 12.9,12.9c7.12447,0 12.9,-5.77553 12.9,-12.9c0,-7.12447 -5.77553,-12.9 -12.9,-12.9z"
                    fill="#ffa9cd"
                  ></path>
                  <path
                    d="M118.25,34.4c5.9297,0 10.75,4.8203 10.75,10.75c0,5.9297 -4.8203,10.75 -10.75,10.75c-5.9297,0 -10.75,-4.8203 -10.75,-10.75c0,-5.9297 4.8203,-10.75 10.75,-10.75M118.25,30.1c-8.3119,0 -15.05,6.7381 -15.05,15.05c0,8.3119 6.7381,15.05 15.05,15.05c8.3119,0 15.05,-6.7381 15.05,-15.05c0,-8.3119 -6.7381,-15.05 -15.05,-15.05z"
                    fill="#ff93c1"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </section>
        <p>
          A full-stack drawing app, created with a partner. Users can create
          their own their own doodles, or view the doodles of others. Built
          with: <span className="emphasis">Ruby on Rails</span>,{" "}
          <span className="emphasis">PostgreSQL</span> and{" "}
          <span className="emphasis">React</span>.
        </p>
        <section className="repo-demo-container">
          <a
            href="https://github.com/aleksarad/doodl-frontend/tree/merge"
            target="_blank"
            rel="noopener noreferrer"
          >
            Repo
          </a>
          <a
            href="https://doodl.netlify.app/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Live
          </a>
          <a
            href="https://www.loom.com/share/0fc1e48dd76a45d99025f5b666c31430"
            target="_blank"
            rel="noopener noreferrer"
          >
            Demo
          </a>
        </section>
      </div>
      <div className="project">
        <section className="name-icon-container">
          <h3 className="project-name">The Hive</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="40"
            height="40"
            viewBox="0 0 172 172"
            style={{ fill: "#000000" }}
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="none"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style={{ mixBlendMode: "normal" }}
            >
              <path
                d="M0,172v-172h172v172z"
                fill="none"
                stroke="none"
                stroke-linecap="butt"
              ></path>
              <g>
                <path
                  d="M135.45,2.15c-10.4361,0 -21.5,4.3 -21.5,4.3l4.3,21.5M152.65,10.75c-10.4361,0 -21.5,4.3 -21.5,4.3l4.3,21.5"
                  fill="none"
                  stroke="#e578a5"
                  stroke-linecap="round"
                ></path>
                <path
                  d="M131.15,66.65c-11.8551,0 -21.5,-9.6449 -21.5,-21.5c0,-11.8551 9.6449,-21.5 21.5,-21.5c17.1785,0 25.8,20.6744 25.8,32.25c0,9.9803 -10.3028,10.75 -24.8497,10.75z"
                  fill="#ffe8f1"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M131.15,25.8c15.5273,0 23.65,19.5951 23.65,30.1c0,7.3573 -7.0047,8.6 -22.6997,8.6h-0.4773h-0.473c-10.6683,0 -19.35,-8.6817 -19.35,-19.35c0,-10.6683 8.6817,-19.35 19.35,-19.35M131.15,21.5c-13.0634,0 -23.65,10.5866 -23.65,23.65c0,13.0634 10.5866,23.65 23.65,23.65c0.3139,0 0.6321,0 0.9503,0c12.8226,0 26.9997,-0.1548 26.9997,-12.9c0,-13.0634 -9.675,-34.4 -27.95,-34.4z"
                  fill="#e578a5"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M92.493,59.2626c-10.3845,0 -26.746,-5.1557 -35.0708,-13.4805c-13.2311,-13.2354 -15.351,-33.0197 -10.8446,-37.5261c0.86,-0.86 3.3153,-1.7802 7.6368,-1.7802c8.8451,0 22.0848,3.827 30.2462,12.2249c12.2421,12.599 16.5894,27.9113 16.5894,37.1993c0,2.4768 -4.4204,3.3626 -8.557,3.3626z"
                  fill="#ffe8f1"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M54.2101,8.6215v0c8.6774,0 21.3237,3.9775 28.7068,11.5756c11.7992,12.1389 15.9831,26.8191 16.0347,35.604c-0.2623,0.3397 -2.0081,1.3072 -6.4629,1.3072c-9.9545,0 -25.6108,-4.9149 -33.5486,-12.8527c-12.6162,-12.6162 -14.1771,-31.1535 -10.8446,-34.486c0.3053,-0.2967 2.0769,-1.1481 6.1146,-1.1481M54.2101,4.3215c-4.2226,0 -7.5637,0.8213 -9.1547,2.408c-5.4739,5.4782 -3.0014,26.7245 10.8446,40.5705c8.815,8.815 25.5721,14.1083 36.5887,14.1083c6.2909,0 10.7113,-1.7243 10.7113,-5.5083c0,-8.2431 -3.5518,-24.6562 -17.2,-38.7c-8.5398,-8.7849 -22.3643,-12.8785 -31.7899,-12.8785z"
                  fill="#e578a5"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M67.4068,66.478c-12.5001,0 -23.6844,-4.3 -31.4846,-12.1002c-7.7916,-7.7873 -14.3362,-17.7848 -17.9568,-27.4254c-3.182,-8.4495 -3.569,-15.5703 -1.0019,-18.1374c1.3459,-1.3416 4.0764,-2.0812 7.7056,-2.0812c9.5159,0 25.0905,5.074 38.4377,16.4045l5.5556,4.6827c12.4829,10.4834 25.3915,21.3237 25.6753,27.7909c0.0516,1.1782 -0.3483,2.1543 -1.2599,3.0659c-3.7582,3.7582 -13.3945,7.8002 -25.671,7.8002z"
                  fill="#ffffff"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M24.6691,8.8838v0c8.8279,0 24.1832,4.9751 37.0445,15.8928c1.8619,1.5824 3.7281,3.1476 5.5685,4.6956c11.5627,9.7094 24.6648,20.7174 24.9056,26.2343c0.0215,0.4859 -0.0774,0.8944 -0.6321,1.4534c-3.5647,3.5647 -13.0032,7.1724 -24.1531,7.1724c-6.9058,0 -19.9821,-1.4921 -29.9667,-11.4724c-16.8216,-16.8216 -22.9362,-38.5452 -18.9544,-42.527c0.7052,-0.7009 2.6961,-1.4491 6.1877,-1.4491M24.6691,4.5838c-4.1581,0 -7.4132,0.8987 -9.2235,2.709c-6.7811,6.7811 1.806,31.4588 18.9544,48.6072c9.3138,9.3138 21.7021,12.7323 33.0068,12.7323c11.8594,0 22.5277,-3.7625 27.1932,-8.4323c8.0754,-8.0754 -11.1069,-22.575 -30.1,-38.7c-13.2268,-11.2316 -29.3776,-16.9162 -39.8309,-16.9162zM64.5,116.3064c-7.1681,0.5547 -12.9,11.7992 -12.9,25.6968c0,13.8976 5.375,25.6968 12.9,25.6968z"
                  fill="#e578a5"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M67.3423,156.477c-1.0105,0 -1.9006,-0.1247 -2.6402,-0.3698c-13.158,-4.3989 -19.5521,-16.383 -19.5521,-36.6274c0,-28.1091 10.1437,-44.2298 27.8339,-44.2298c2.8294,0 5.8136,0.4257 8.858,1.2642c7.5594,2.0812 14.4007,7.9206 18.7738,16.0218c5.2847,9.804 6.1834,21.4656 2.5112,32.8434c-6.0329,18.6921 -25.5334,31.0976 -35.7846,31.0976z"
                  fill="#ffa9cd"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M72.9839,77.4v0c2.6359,0 5.4223,0.3999 8.2818,1.1868c6.8929,1.9006 13.416,7.4949 17.4537,14.9683c5.0095,9.2794 5.848,20.3476 2.3607,31.1621c-5.7405,17.802 -24.1101,29.6098 -33.7378,29.6098c-0.7697,0 -1.4448,-0.0903 -1.9565,-0.2623c-7.7658,-2.5972 -18.0858,-9.0042 -18.0858,-34.5849c0,-26.7417 9.3611,-42.0798 25.6839,-42.0798M72.9839,73.1c-16.383,0 -29.9839,13.1752 -29.9839,46.3798c0,21.6849 7.1595,34.0259 21.0184,38.6656c0.9718,0.3268 2.0898,0.4816 3.3196,0.4816c11.0854,0 31.4502,-12.8097 37.8314,-32.5897c8.0754,-25.026 -6.1275,-47.0162 -22.7599,-51.5957c-3.1949,-0.8815 -6.3597,-1.3416 -9.4256,-1.3416z"
                  fill="#e578a5"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M105.823,96.75c-6.4328,0 -13.0677,-2.9455 -18.1976,-8.0754c-9.2665,-9.2665 -10.7887,-22.833 -3.3841,-30.2333c3.0702,-3.0702 7.2326,-4.6913 12.0357,-4.6913c6.4328,0 13.0677,2.9455 18.1976,8.0754c9.2665,9.2665 10.7887,22.833 3.3841,30.2333c-3.0702,3.0702 -7.2283,4.6913 -12.0357,4.6913z"
                  fill="#ffe8f1"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <path
                  d="M96.277,55.9v0c5.8652,0 11.9454,2.7133 16.6797,7.4476c8.428,8.428 9.9502,20.6271 3.3841,27.1932c-2.6617,2.6531 -6.2952,4.0592 -10.5135,4.0592c-5.8695,0 -11.9454,-2.7133 -16.6797,-7.4476c-8.428,-8.428 -9.9502,-20.6271 -3.3841,-27.1932c2.6531,-2.6531 6.2909,-4.0592 10.5135,-4.0592M96.2727,51.6c-5.1471,0 -9.976,1.7415 -13.5536,5.3191c-8.2517,8.2517 -6.7381,23.1512 3.3841,33.2734c5.7362,5.7362 12.9989,8.7075 19.7241,8.7075c5.1471,0 9.976,-1.7415 13.5536,-5.3191c8.2517,-8.2517 6.7381,-23.1512 -3.3841,-33.2734c-5.7362,-5.7362 -12.9989,-8.7075 -19.7241,-8.7075z"
                  fill="#e578a5"
                  stroke="none"
                  stroke-linecap="butt"
                ></path>
                <g fill="#e578a5" stroke="none" stroke-linecap="butt">
                  <path d="M127.1166,32.5166c3.7539,-3.7496 10.5264,-3.0616 15.1274,1.5394c4.601,4.601 5.289,11.3735 1.5394,15.1231c-3.7496,3.7496 -10.5221,3.0616 -15.1231,-1.5394c-4.6053,-4.5967 -5.1041,-11.5584 -1.5437,-15.1231z"></path>
                </g>
                <g fill="#ffe8f1" stroke="none" stroke-linecap="butt">
                  <path d="M103.1269,110.1531c-8.5828,-1.6082 -17.0366,-6.1275 -23.9424,-13.0333c-5.7018,-5.7018 -9.6578,-12.3324 -11.8336,-19.0361c-2.8595,0.7181 -5.4352,2.0124 -7.7185,3.8399c2.6316,7.5594 7.1122,14.921 13.4676,21.2764c8.6258,8.6258 19.0963,13.8589 29.4077,15.5875c0.5117,-2.9025 0.7181,-5.7878 0.6192,-8.6344z"></path>
                </g>
                <g fill="#ffe8f1" stroke="none" stroke-linecap="butt">
                  <path d="M64.4226,112.402c-5.3922,-5.3922 -9.8513,-11.3735 -13.4031,-17.6816c-1.2642,3.4142 -2.2145,7.3143 -2.838,11.6487c2.9627,4.2183 6.3339,8.2904 10.1609,12.1131c10.1609,10.1609 21.9773,17.2301 34.0689,21.2506c1.9264,-2.2145 3.6679,-4.6569 5.1772,-7.2756c-11.9583,-3.5088 -23.4952,-10.3888 -33.1659,-20.0552z"></path>
                </g>
                <g fill="#ffe8f1" stroke="none" stroke-linecap="butt">
                  <path d="M49.3425,127.4821c-0.6364,-0.6364 -1.1911,-1.3115 -1.806,-1.9565c0.4558,6.1834 1.5996,11.0295 3.1906,14.8221c6.2393,5.3191 12.8312,9.8427 19.6338,13.6224c3.0788,-0.6149 6.6521,-2.064 10.3071,-4.2828c-11.2617,-5.332 -21.9343,-12.814 -31.3255,-22.2052z"></path>
                </g>
              </g>
            </g>
          </svg>
        </section>
        <p>
          A buzz-worthy social media app, created with a partner, in which users
          can create posts, like the post of others, follow others, and view
          trending posts. Built with:{" "}
          <span className="emphasis">Ruby on Rails</span>, and{" "}
          <span className="emphasis">SQLite</span>.
        </p>
        <section className="repo-demo-container">
          <a
            href="https://github.com/aleksarad/the-hive"
            target="_blank"
            rel="noopener noreferrer"
          >
            Repo
          </a>
          <a
            href="https://www.loom.com/share/9b05db1579874eaba5a43f77b090373d"
            target="_blank"
            rel="noopener noreferrer"
          >
            Demo
          </a>
        </section>
      </div>
      <div className="project">
        <section className="name-icon-container">
          <h3 className="project-name">Pokemon Trainer</h3>
          <img
            src="https://img.icons8.com/color/48/000000/jigglypuff.png"
            alt="small pink icon of jigglypuff"
          />
        </section>
        <p>
          A charming CLI application that allows a user to teach moves to
          daycare pokemon. Complete with nostalgic sounds. Built with:{" "}
          <span className="emphasis">Ruby</span>, and{" "}
          <span className="emphasis">SQLite</span>.
        </p>
        <section className="repo-demo-container">
          <a
            href="https://github.com/aleksarad/pokemon-trainer"
            target="_blank"
            rel="noopener noreferrer"
          >
            Repo
          </a>
          <a
            href="https://youtu.be/jjU1xA1RJSc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Demo
          </a>
        </section>
      </div>
      <p style={{ fontSize: "1rem", textAlign: "center" }} id="project-footer">
        Portfolio designed and coded by me, check out the repo{" "}
        <span className="emphasis">
          <a
            href="https://github.com/aleksarad/aleksarad.github.io"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </span>
        .
      </p>
    </div>
  );
}

export default Projects;
